import {createSlice} from '@reduxjs/toolkit'
import hit from 'src/services/manager'

const initialState={
    list:[]
}

const ordersSlice=createSlice({
    name:"orders",
    initialState,
    reducers:{
        setOrderList:(state,action)=>{
            state.list=action.payload
        }
    }
})

export const {setOrderList}=ordersSlice.actions

export const getOrdersListThunk=()=>{
    return async(dispatch)=>{
        try{
            let res=await hit("/admin/orders","get")
            if(!res.err){
                dispatch(setOrderList(res?.data))
            }
        }catch(err){

        }finally{

        }
    }
}

export default ordersSlice.reducer